import { sub } from "date-fns";

const { createSlice, nanoid } = require("@reduxjs/toolkit");

const initialState={
    todo:[{id: 1, title:"this is the fist title", date: sub(new Date(), { minutes: 10 }).toISOString() },
           {id:2, title: "this is the second title", date: sub(new Date(), { minutes: 10 }).toISOString()}]
}

export const todosSlice= createSlice({
    name:'todos',
    initialState,
    reducers: {
        addTodos : {
            reducer(state,action){
                state.todo.push(action.payload)
            },
            prepare(title){
                return{
                    payload:{
                        id: nanoid(),
                        title,
                        date: new Date().toISOString(),
                    }
                }
            }
        },
        clearCart: (state) => {
            state.todo= [];
        },
        removeTodos: (state, action) => {
            const itemId = action.payload;
            state.todo = state.todo.filter((item) => item.id !== itemId);
        },
      
       

    }

})
export default todosSlice.reducer
export const {addTodos,clearCart, removeTodos,updateTodos}=todosSlice.actions
export const selectAllTodo=(state)=>state.todos.todo